import { render, staticRenderFns } from "./AuditCredentialsForm.vue?vue&type=template&id=48e695de&"
import script from "./AuditCredentialsForm.vue?vue&type=script&lang=js&"
export * from "./AuditCredentialsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports